import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import {
  subscriptionList,
  subscriptionAssign,
  subscriptionListPartner,
  subscriptionPartnerDelete,
  subscriptionSeller,
  createPaymentRequest,
  verifyPaymentRequest,
  PaymentTransactionList,
  getSubscriptionList,
  getSubscriptionListTenant, createSubscriptionPlan,
  updateSubscriptionPlan, deleteSubscriptionPlan, initStripePayment, initInvoiceStripePayment
} from "../../services/subscription.js";

@Module({
  namespaced: true
})
export default class Subscription extends VuexModule {
  //state
  subscriptionGetData = {};
  subscribedPartnerList = {};
  subscriptionSellerMyList = {};
  transactionsList = [];
  subscriptionList = [];
  tenantSubscriptionList = [];

  //Actions
  @Action
  public async fetchSubscriptionSellerMyList() {
    try {
      const data = await subscriptionSeller();
      this.context.commit("setSubscriptionSellerMyList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchSubscriptionList() {
    try {
      const data = await subscriptionList();
      this.context.commit("setSubscriptionList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async assignSubscriptionList(payload) {
    try {
      const data = await subscriptionAssign(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async partnerSubscriptionDelete(payload) {
    try {
      const data = await subscriptionPartnerDelete(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async initStripePaymentAction(payload) {
    try {
      const data = await initStripePayment(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async initInvoiceStripePaymentAction(payload) {
    try {
      const data = await initInvoiceStripePayment(payload.id, payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getSubscriptionPartner(payload) {
    try {
      const data = await subscriptionListPartner(payload);
      this.context.commit("setSubscriptionPartner", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createPaymentRequest(payload) {
    try {
      const data = await createPaymentRequest(payload.method, payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async verifyPaymentRequest(payload) {
    try {
      const data = await verifyPaymentRequest(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async PaymentTransactionList(payload) {
    try {
      const data = await PaymentTransactionList(payload);
      this.context.commit("setTransactionsList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getSubscriptionListAction() {
    try {
      const data = await getSubscriptionList();
      this.context.commit("getSubscriptionListMutation", data.data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async addSubscriptionAction(payload) {
    try {
      const data = await createSubscriptionPlan(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async updateSubscriptionAction(payload) {
    try {
      const data = await updateSubscriptionPlan(payload.id, payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async deleteSubscriptionAction(id) {
    try {
      const data = await deleteSubscriptionPlan(id);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
public async getSubscriptionListTenantAction() {
  try {
    const data = await getSubscriptionListTenant();
    this.context.commit("getSubscriptionListTenantMutation", data.data.response);
    return data;
  } catch (error) {}
}
  //Mutations

  @Mutation
  public getSubscriptionListTenantMutation(data: any) {
    this.tenantSubscriptionList = data;
  }

  @Mutation
  public setSubscriptionSellerMyList(data: any) {
    this.subscriptionSellerMyList = data;
  }

  @Mutation
  public setSubscriptionList(data: any) {
    this.subscriptionGetData = data;
  }

  @Mutation
  public setSubscriptionPartner(data: any) {
    this.subscribedPartnerList = data;
  }

  @Mutation
  public setTransactionsList(data: any) {
    this.transactionsList = data;
  }
  @Mutation
  public getSubscriptionListMutation(data: any) {
    this.subscriptionList = data;
  }

  //Getters

  get GetSubscriptionList() {
    return this.subscriptionGetData;
  }

  get GetSubscriptionListTenant() {
    return this.tenantSubscriptionList;
  }

  get GetSubscriptionPartnerList() {
    return this.subscribedPartnerList;
  }

  get GetSubscriptionSellerMyList() {
    return this.subscriptionSellerMyList;
  }

  get GetTransactionsList() {
    return this.transactionsList.reverse()
  }
}
